import axios from "axios";

const openedEndpoints: {path: string, method: string}[] = [
    {
        path: '/login',
        method: 'post'
    },
    {
        path: '/users',
        method: 'post'
    }
]
const baseURL = process.env.REACT_APP_API_URL;
const api = axios.create({ baseURL });

api.interceptors.request.use(
    async (config) => {
        const isOpenedEndpoint = openedEndpoints.filter((endpoint) => {
            return config.url?.includes(endpoint.path) && (config.method === endpoint.method || endpoint.method === 'any')
        }).length > 0

        const user = JSON.parse(localStorage.getItem('token')?? '{}')

        if(!isOpenedEndpoint && !user.token) {
            throw new Error("Unautenticated");
        }

        if(user.token) {
            config.headers = {
                'Authorization': `Bearer ${ user.token }`,
                'Accept': 'application/json',
            }
        }
    
        return config;
    },
    (error) => {
        return Promise.reject(error);
      });

export {api};
